module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: {
      'app-login': !_vm.auth
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.auth && _vm.sidenav) ? _c('app-sidenav') : _vm._e(), _vm._v(" "), (_vm.auth) ? _c('app-navbar') : _vm._e(), _vm._v(" "), (_vm.main) ? _c('v-content', [(_vm.auth) ? _c('app-breadcrumbs') : _vm._e(), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('app-messages'), _vm._v(" "), _c('app-alert'), _vm._v(" "), _c('app-confirm'), _vm._v(" "), _c('vue-progress-bar'), _vm._v(" "), _c('app-loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c9a2f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 501
// module chunks = 2